<template lang="pug">
.video-container.container.content(:class="[spacingTop, spacingBottom]")
    .video-box
        video.vjs-default-skin.vjs-big-play-centered(
          ref="player"
          class="video-js"
          loop="true"
          controls
        )
          source(
            :src="src" 
            :type="mime"
            )
    .video-info
        h3.is-size-4-desktop.is-size-4-tablet.is-size-4-mobile(v-if="videoTitle") {{ videoTitle }}
        .video-desc(v-if="videoDesc" v-html="videoDesc") 
</template>

<script>

import _ from 'lodash'

import videojs from 'video.js';
import 'videojs-http-source-selector';
import 'videojs-contrib-quality-levels';
import 'video.js/dist/video-js.min.css';

export default {
    name: 'Video',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            player: null
        };
    },
    watch: {
        src(fresh, old) {
            if (old && fresh !== old && this.player) {
                this.player.pause();
                this.player.src([
                    {
                        type: this.mime,
                        src: this.src
                    }
                ]);
                // this.initialise()
                this.player.load();
                this.player.play();
            }
        }
    },
    computed: {
        spacingTop() {
            let spacingTop = 'spacingTopStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingTop');
                if (setting && setting.value !== undefined) spacingTop = setting.value;
            }
            return spacingTop;
        },

        spacingBottom() {
            let spacingBottom = 'spacingBottomStandard';

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'spacingBottom');
                if (setting && setting.value !== undefined) spacingBottom = setting.value;
            }
            return spacingBottom;
        },
        contents() {
            return this.section.contents || [];
        },

        videoTitle() {
            let videoTitle = this.contents.find(content => content.key === 'heading');
            return videoTitle.title
        },

        videoDesc() {
            let videoDesc = this.contents.find(content => content.key === 'content');
            return videoDesc.text
        },

        media() {
            let media = this.contents.find(content => content.key === 'media')
            return media.media;
        },
        videoObject() {
            return this.media.find(el => el.type === 'video');
        },
        isHls() {
            return !!_.get(this.videoObject.video, 'hls');
        },
        mime() {
            if (this.isHls) {
                return this.videoObject.video.hls.mime;
            } else {
                return this.videoObject.video.source.mime;
            }
        },
        src() {
            let src;
            if (this.videoObject.video) {
                if (this.isHls) {
                    src = _.get(this.videoObject.video, 'hls.url');
                } else {
                    src = _.get(this.videoObject.video, 'source.url');
                }
            }
            // this.activeProductMedia.data.hls
            return src;
        }
    },
    methods: {
        initialise() {
            const options = {
                muted: true,
                language: 'de',
                preload: 'auto',
                fluid: true,
                aspectRatio: '16:9',
                //autoplay: true,
                // inactivityTimeout: 1,
                html5: {
                    hls: {
                        overrideNative: true,
                        limitRenditionByPlayerDimensions: true,
                        useDevicePixelRatio: true,
                        bandwidth: 16777216
                    },
                    nativeAudioTracks: false,
                    nativeVideoTracks: false,
                    useBandwidthFromLocalStorage: true
                }
            };
            this.player = videojs(this.$refs.player, options);
            this.player.httpSourceSelector();

            // this.player.controls(false)

            this.player.on('ended', () => {
                this.player.posterImage.show();
                // vid.bigPlayButton.show();
                this.player.currentTime(0);
            });

            this.player.on('touchstart', event => {
                // this.$refs.player.parentNode.classList.add('vjs-show-controls');
                if (event.target.nodeName === 'VIDEO') {
                    if (this.player.paused()) this.player.play();
                    else this.player.pause();
                }
            });

            videojs.log.level('error');
        }
    },
    mounted() {
        this.initialise();
    },
    beforeDestroy() {
        if (this.player) this.player.dispose();
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"
.video-container
    margin: 0 auto
    max-width: 900px
    .video-info
        h3
            margin-top: 10px
            color: $primary
            font-weight: 500
            margin-bottom: 0
    .video-box
        .video-js
          width: 100%

</style>
